module finadai.services {
  export class FilesService {
    static instanceName = 'filesService';
    constructor(private $http: ng.IHttpService, private proxifier, private $httpParamSerializer: ng.IHttpParamSerializer){

    }
    upload(data){
      return this.$http.post([this.proxifier(), 'finadai', 'customers', 'file'].join('/'), data);
    }
  }
}